import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import {FormGroup,FormBuilder} from '@angular/forms';
import{validacionService, listadosService} from '../../services/api-rest.service';
import{MessageService} from '../../services/message.service';

@Component({
  selector: 'form-ubicacion-ecuador',
  templateUrl: './ubicacion-ecuador.component.html',
  providers:[validacionService,listadosService, MessageService]
})
export class UbicacionEcuadorComponent implements OnInit,OnChanges {
  @Input() ubicacion: FormGroup
  @Input() preview: boolean = true
  @Input() estadoForm: number
  provincias: any[]
  cantones: any[]
  parroquias: any[]
  
  constructor(
    private val : validacionService,
    private listadosService: listadosService
  ) { 

  }
  ngOnInit() {
    this.listadosService.provincias().subscribe(
      listas => {
        if(listas != null){
          this.provincias = listas
          if(this.ubicacion.get('provincia').value != null)
            this.onChangeCantones(this.ubicacion.get('provincia').value, false)

          if(this.ubicacion.get('canton').value != null)
            this.onChangeParroquias(this.ubicacion.get('canton').value)
        }
        
      }
    )
  }

  ngOnChanges(changes:SimpleChanges) {
    if(changes.preview != undefined
      && changes.preview.currentValue != undefined 
      && changes.preview.currentValue) this.onPreview()
    
    if(changes.estadoForm != undefined
        && changes.estadoForm.currentValue != undefined ){
          if(this.ubicacion.get('provincia').value != null)
            this.onChangeCantones(this.ubicacion.get('provincia').value, false)

          if(this.ubicacion.get('canton').value != null)
            this.onChangeParroquias(this.ubicacion.get('canton').value)
    }

  }
  onPreview(){
      this.ubicacion.disable()
  }

  onChangeCantones(id, encerar = true){
      if(encerar)
        this.ubicacion.patchValue({
          canton: null,
          parroquia: null
        })
      this.cantones = this.val.buscarId(this.provincias,id)[0].cantones
  }
  onChangeParroquias(id){
      this.parroquias = this.val.buscarId(this.cantones,id)[0].parroquias
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/element/formularios/ubicacion-ecuador.component.ts